export default {
  data() {
    return {
      pagination: {
        current: null,
        next: 1,
      },
    };
  },
  computed: {
    nextPageExists() {
      return !!this.pagination.next;
    },
  },
  methods: {
    async infiniteFetcher() {
      throw new Error(
        'infiniteFetcher() must be defined in parent component' +
          ' and return Promise.resolve(data)'
      );
    },
    updatePagination(current, next) {
      Object.assign(this.pagination, {
        current,
        next,
      });
    },
    resetPagination() {
      this.updatePagination(null, 1);
    },
    handleInfinite($state) {
      return this.infiniteFetcher()
        .then(({ pagination }) => {
          const { next_page: next } = pagination;

          if (!next) {
            $state.complete();

            return;
          }

          $state.loaded();
        })
        .catch(() => $state.error());
    },
  },
};
